export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/fallback_6.e56d60d.webp";